<template>
  <div>
    <button id="show-modal"
            class="btn btn-md border border-primary text-primary btn-imprimir"
            type="submit"
            @click="$bvModal.show('show-modal-imprimir')">
      <icon-svg icon="print"
                class="icon--sm icons--primary btn-icone" />
      Imprimir
    </button>
    <b-modal id="show-modal-imprimir" 
             centered
             size="lg"
             title="Imprimir frente de caixa"
             header-bg-variant="secondary"
             header-text-variant="white">
      <div class="d-block text-center mb-2">
        <div class="text-left">
          Número do caixa
          <div class="d-flex">
            <input type="text" 
                   size="12"
                   class="mr-4 mt-2">
            <b-form-checkbox v-model="check"
                             name="check_numero_do_caixa"
                             value="caixa"
                             unchecked-value="check_numero_do_caixa"
                             switch>
              usar frente e verso
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer="{ close }">
        <button type="button"
                class="btn btn-close-modal"
                @click="close()">
          Cancelar
        </button>
        <button type="button"
                class="btn btn-secondary">
          Imprimir
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: "BotaoImprimir",
    data () {
      return {
        check: ''
      }
    }
  }
</script>

<style scoped>
  .btn-imprimir:hover {
    background-color:#1c7af5;
    color: #fff !important;
  }
  .btn-imprimir:hover .btn-icone {
    background-color:#1c7af5;
    fill: #fff !important;
  }
</style>